import { Panel } from '@epam/promo';
import { BlankBlock } from 'components/common';
import { useVersionsGetQuery } from 'hooks/api/useVersionsGetQuery';
import { VersionDisplayText } from './VersionDisplayText';
import css from './VersionPage.module.scss';

const NO_VERSIONS_AVAILABLE_HEADER = 'Versions are not available';
const NO_VERSIONS_AVAILABLE_MESSAGE = 'Please try again later';
const VERSIONS_HEADER = 'VERSIONS INFO:';

export const VersionPage = () => {
  const { isLoading, versions } = useVersionsGetQuery();

  return (
    <div className={css['versions-card__wrapper']}>
      <div
        className={`${css['versions-card__spinner-container']} ${
          isLoading ? 'skeleton-loader' : ''
        }`}>
        {versions ? (
          <Panel shadow background="white" cx={css['versions-card__container']}>
            <VersionDisplayText versionText={VERSIONS_HEADER} />
            <VersionDisplayText versionText={versions.bot} />
            <VersionDisplayText versionText={versions.backend} />
            <VersionDisplayText versionText={versions.frontend} />
          </Panel>
        ) : (
          <BlankBlock
            header={NO_VERSIONS_AVAILABLE_HEADER}
            message={NO_VERSIONS_AVAILABLE_MESSAGE}
          />
        )}
      </div>
    </div>
  );
};
